import { ADD_SURVEY_FAIL, ADD_SURVEY_REQUEST, ADD_SURVEY_SUCCESS, CHANGE_ADD_SURVEY_FORM_DATA, CLEAR_SURVEY_FORM_DATA, DELETE_SURVEY_FAIL, DELETE_SURVEY_REQUEST, DELETE_SURVEY_SUCCESS, GET_SURVEY_FAIL, GET_SURVEY_LIST_DATA_FAIL, GET_SURVEY_LIST_DATA_REQUEST, GET_SURVEY_LIST_DATA_SUCCESS, GET_SURVEY_REQUEST, GET_SURVEY_SUCCESS, LOGIN_FAIL, LOGIN_REQUEST, LOGIN_SUCCESS } from "../constant"

const initialState = {
  surveyData: [],
  totalRecords: null,
  addSurveyFormData: {},

  surveyDataLoading: false
}

const surveyReducer = (state = initialState, action) => {
  switch (action.type) {
    //Get survey
    case GET_SURVEY_REQUEST:
      return {
        ...state,
        surveyData: [],
        totalRecords: null,
        surveyDataLoading: true
      }
    case GET_SURVEY_SUCCESS:
      return {
        ...state,
        surveyData: action.payload?.data,
        totalRecords: action.payload?.totalRecords,
        surveyDataLoading: false
      }
    case GET_SURVEY_FAIL:
      return {
        ...state,
        surveyData: [],
        totalRecords: null,
        surveyDataLoading: false
      }

    //Get survey list data
    case GET_SURVEY_LIST_DATA_REQUEST:
      return {
        ...state,
      }
    case GET_SURVEY_LIST_DATA_SUCCESS:
      const listData = action.payload
      let tmpList = state?.surveyData?.map((survey) => ({ ...survey, ...listData[survey.survey_id] }))
      // console.log('tmpList', tmpList);
      return {
        ...state,
        surveyData: [...tmpList]
      }
    case GET_SURVEY_LIST_DATA_FAIL:
      return {
        ...state,
      }

    //Add survey
    case ADD_SURVEY_REQUEST:
      return {
        ...state,
      }
    case ADD_SURVEY_SUCCESS:
      return {
        ...state,
        addSurveyFormData: {},
      }
    case ADD_SURVEY_FAIL:
      return {
        ...state,
      }

    //Get survey
    case DELETE_SURVEY_REQUEST:
      return {
        ...state,
      }
    case DELETE_SURVEY_SUCCESS:
      return {
        ...state,
      }
    case DELETE_SURVEY_FAIL:
      return {
        ...state,
      }

    //Clear form data
    case CLEAR_SURVEY_FORM_DATA:
      return {
        ...state,
        addSurveyFormData: {}
      }

    //Add survay form data
    case CHANGE_ADD_SURVEY_FORM_DATA:
      return {
        ...state,
        addSurveyFormData: { ...state.addSurveyFormData, [action.payload?.key]: action.payload?.data }
      }

    default:
      return state;
  }
}

export { surveyReducer }